// ============================================================================
// Allows custom controls to update quantity inputs
// ============================================================================
//
// ============================================================================


// -------------------------------------
// Variables
// -------------------------------------

// Selectors
const FORM_INPUT_CONTAINER_SELECTOR = '.form__input-container';
const FORM_INPUT_SELECTOR           = '.form__input';
const FORM_INCREMENT_SELECTOR       = '.form__increment';

// Classes
const FORM_INCREMENT_UP_CLASS = 'form__increment--up';

// Events
const changeEvent = new Event('change');


// -------------------------------------
// Helpers
// -------------------------------------

function handleClick(event) {
    handleQuantityChange(event.target, 'click');
}

function handleKeydown(event) {
    if (event.key === 'Enter') {
        event.preventDefault();
        handleQuantityChange(event.target, 'keydown');
    }
}

function handleQuantityChange(formIncrementButton, source) {
    const quantityInput = formIncrementButton.closest(FORM_INPUT_CONTAINER_SELECTOR).querySelector(FORM_INPUT_SELECTOR);

    updateQuantityInput(formIncrementButton, quantityInput);

    if (source === 'click') {
        quantityInput.focus();
    }
}

function updateQuantityInput(formIncrementButton, quantityInput) {
    const currentValue = quantityInput.value;
    let newValue;

    if (formIncrementButton.classList.contains(FORM_INCREMENT_UP_CLASS)) {
        newValue = parseFloat(currentValue) + 1;
    } else {
        // Don't allow decrementing below 1
        if (currentValue > 1) {
            newValue = parseFloat(currentValue) - 1;
        } else {
            newValue = 1;
        }
    }

    quantityInput.value = newValue;
    quantityInput.dispatchEvent(changeEvent);
}


// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', () => {
    const formIncrements = document.querySelectorAll(FORM_INCREMENT_SELECTOR);

    formIncrements.forEach(formIncrement => {
        formIncrement.addEventListener('click', handleClick);
        formIncrement.addEventListener('keydown', handleKeydown);
    });
});
